import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { User } from 'types/user'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { getTrackPlaying } from '@disco/state-management/selectors/media'
import { getUser } from '@disco/state-management/selectors/user'
import DiscoApp from 'containers/DiscoApp'
import useEventListener from 'hooks/use-event-listener'
type Props = {
  children?: React.ReactNode | null | undefined
  bannersHeightPx?: number
}

const Home = ({
  children,
  bannersHeightPx,
}: Props): React.ReactElement<'div'> => {
  const playerVisible = useSelector(state => !!getTrackPlaying(state))
  const user: User = useSelector(getUser)
  const dispatch = useDispatch()
  const onunload = useCallback(() => {
    dispatch(sendMixpanelEvent('Logout'))
  }, [dispatch])
  useEventListener('beforeunload', onunload)
  return (
    <div className="Content" data-player-visible={playerVisible || null}>
      <DiscoApp
        loggedIn={Boolean(user.loggedIn)}
        bannersHeightPx={bannersHeightPx}
      />
      {children}
    </div>
  )
}

export default Home
